// extracted by mini-css-extract-plugin
export default {"content":"style_content__8EWjl","keywordTextBox":"style_keywordTextBox__s8noA","keywordButton":"style_keywordButton__Rb7oM","icon":"style_icon__btBr7"};